import React, { useState, useEffect, useMemo } from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const {
    blockSize,
    blockMargin,
    fontSize,
    hideColorLegend,
    hideTotalCount,
    hideMonthLabels,
    daysToShow,
    totalCountLabel,
  } = useMemo(() => {
    if (width < 360) {
      return {
        blockSize: 7,
        blockMargin: 1,
        fontSize: 9,
        hideColorLegend: true,
        hideTotalCount: true,
        hideMonthLabels: false,
        daysToShow: 120,
        totalCountLabel: null,
      };
    }
    if (width < 480) {
      return {
        blockSize: 8,
        blockMargin: 1.5,
        fontSize: 10,
        hideColorLegend: true,
        hideTotalCount: false,
        hideMonthLabels: false,
        daysToShow: 180,
        totalCountLabel: "{{count}} contribuciones en el último año",
      };
    }
    if (width < 576) {
      return {
        blockSize: 9,
        blockMargin: 2,
        fontSize: 11,
        hideColorLegend: true,
        hideTotalCount: false,
        hideMonthLabels: false,
        daysToShow: 240,
        totalCountLabel: "{{count}} contribuciones en el último año",
      };
    }
    if (width < 768) {
      return {
        blockSize: 11,
        blockMargin: 3,
        fontSize: 14,
        hideColorLegend: false,
        hideTotalCount: false,
        hideMonthLabels: false,
        daysToShow: 300,
        totalCountLabel: "{{count}} contribuciones en el último año",
      };
    }
    return {
      blockSize: 14,
      blockMargin: 4,
      fontSize: 16,
      hideColorLegend: false,
      hideTotalCount: false,
      hideMonthLabels: false,
      daysToShow: null,
      totalCountLabel: "{{count}} contribuciones en el último año",
    };
  }, [width]);

  const transformData = useMemo(() => {
    if (!daysToShow) return undefined;
    return (data) => {
      const sliced = data.slice(-daysToShow);
      return sliced;
    };
  }, [daysToShow]);

  const labels = useMemo(() => {
    const base = {
      legend: {
        less: "Menos",
        more: "Más",
      },
    };
    if (totalCountLabel) {
      base.totalCount = totalCountLabel;
    }
    return base;
  }, [totalCountLabel]);

  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "10px",
        color: "#c9d1d9",
      }}
      className="github-section"
    >
      <h1 className="project-heading github-heading" style={{ paddingBottom: "20px" }}>
        Días que <strong className="purple">Codeo</strong>
      </h1>
      <div className="github-calendar-wrapper">
        <GitHubCalendar
          username="LautaroPena02"
          blockSize={blockSize}
          blockMargin={blockMargin}
          color="#58a6ff"
          fontSize={fontSize}
          hideColorLegend={hideColorLegend}
          hideTotalCount={hideTotalCount}
          hideMonthLabels={hideMonthLabels}
          transformData={transformData}
          transformTotalCount={false}
          labels={labels}
        />
      </div>
    </Row>
  );
}

export default Github;
